/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_Back_To_HomeInputs */

const en_not_found_back_to_home = /** @type {(inputs: Not_Found_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Home`)
};

const es_not_found_back_to_home = /** @type {(inputs: Not_Found_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al inicio`)
};

/**
* | output |
* | --- |
* | "Back to Home" |
*
* @param {Not_Found_Back_To_HomeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const not_found_back_to_home = /** @type {((inputs?: Not_Found_Back_To_HomeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_Back_To_HomeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_not_found_back_to_home(inputs)
	return es_not_found_back_to_home(inputs)
});